import React, { useState } from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { Form, Input, Upload, Select } from "antd";
import SelectAddress from "../SelectAddress";
import toast from "react-hot-toast";
import RadioGroup from "../../atoms/RadioGroup";
import ComboField from "./ComboField";
import { ReactComponent as DownIcon } from "../../svgs/dropdown_icon.svg";
import RegistryDetails from "../../organisms/KycForm/RegistryDetails";
import Button from "../../atoms/Button";
import { emailotpRequest } from "../../../utils/API/emailOTPrequest";
import { verifyOtp } from "../../../utils/API/verifyOtp";

const { TextArea } = Input;

const options = [
  { label: "Private", value: "private" },
  { label: "Public", value: "public" }
];

const OrganizationForm = ({
  form,
  Country,
  State,
  City,
  registries,
  documents,
  setDocuments,
  isDisabledForm
}) => {
  const { userType } = useSelector((state) => state.authReducer);
  const countries = Country.getAllCountries();
  const inputClass = "border-0 border-b-2 rounded-none";
  const [isCodeSent, setCodeSent] = useState(false);
  const [inputCode, setInputCode] = useState("");
  const [isVarifyCode, setVarifyCode] = useState(false);
  const [isCode2Sent, setCode2Sent] = useState(false);
  const [inputCode2, setInputCode2] = useState("");
  const [isVarifyCode2, setVarifyCode2] = useState(false);
  const [email, setEmail] = useState("");

  const handleSentCode = () => {
    setCodeSent(true);
  };

  const handleVarifyCode = () => {
    if (inputCode !== "") {
      setVarifyCode(true);
    } else {
      toast.error("Wrong OTP");
    }
  };

  const handleOtpInput = (e) => {
    setInputCode(e.target.value);
  };

  const handleOtpInput2 = (e) => {
    setInputCode2(e.target.value);
  };

  const handleSentCode2 = async () => {
    try {
      const userTypeValue = userType;
      await emailotpRequest({ email, userType: userTypeValue });
      setCode2Sent(true);
      setVarifyCode2(false);
      toast.success("OTP sent to your email");
    } catch (error) {
      toast.error("Failed to send OTP. Please try again.");
    }
  };

  const handleVarifyCode2 = async () => {
    try {
      const userTypeValue = userType;
      await verifyOtp({ code: inputCode2, email, userType: userTypeValue });
      setVarifyCode2(true);
      toast.success("OTP verified successfully");
    } catch (error) {
      toast.error("Wrong OTP, please try again.");
    }
  };

  return (
    <div className="organization-form">
      <h3 className="text-2xl font-medium text-[#252525] mb-6 mt-4">
        Organization information
      </h3>
      <Form.Item
        name="organizationInformationCompanyType"
        label="Which Type of Company are you in?"
        rules={[
          {
            required: true,
            message: "Please select one option"
          }
        ]}
        labelCol={{ span: 24 }}
      >
        <RadioGroup options={options} className="font-normal" />
      </Form.Item>
      <Form.Item
        label="Organization Name"
        className="font-normal"
        name="organizationInformationOrganizationName"
        rules={[
          {
            required: true,
            message: "Please enter organization name"
          }
        ]}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 12 }}
      >
        <Input className={inputClass} />
      </Form.Item>
      <SelectAddress
        stateName={{
          addressLine: "organizationInformationAddressLine",
          country: "organizationInformationCountry",
          state: "organizationInformationState",
          city: "organizationInformationCity",
          pincode: "organizationInformationPincode"
        }}
        Country={Country}
        State={State}
        City={City}
        form={form}
      />
      <div className="flex upload-section">
        <div className="w-1/2 pr-8">
          <ComboField
            documents={documents}
            setDocuments={setDocuments}
            stateName={"organizationInformationCompanyRegisteredAddress"}
            label={
              "Unique Identification Number (CIN)"
            }
          />
        </div>
        <div className="w-1/2">
          <ComboField
            documents={documents}
            setDocuments={setDocuments}
            stateName={"organizationInformationCompanyTaxId"}
            label={"VAT/Tax ID"}
          />
        </div>
      </div>

      <div className="flex">
        <div className="w-1/2 pr-8">
          <ComboField
            documents={documents}
            setDocuments={setDocuments}
            stateName={"organizationInformationPanId"}
            label={"Pan ID"}
          />
        </div>
        <div className="w-1/2">
          <ComboField
            documents={documents}
            setDocuments={setDocuments}
            stateName={"organizationInformationDunsNumber"}
            label={"DUNS Number"}
          />
        </div>
      </div>
      <Form.Item
        label={"Organization Contact details"}
        labelCol={{ span: 24 }}
        required
      >
        <div>
          <Form.Item
            className="w-[calc(100%/4)] mr-6"
            name="organizationInformationWebsiteLink"
            rules={[
              {
                type: "url",
                message: "The input is not a valid website link"
              },
              {
                required: true,
                message: "Please enter website link"
              }
            ]}
          >
            <Input className={inputClass} type="url" placeholder="Website" />
          </Form.Item>
          <div className="flex">
            <Form.Item
              initialValue={"91"}
              name={"organizationInformationPhoneCode"}
              className="w-[80px] mr-2"
              rules={[
                {
                  required: true,
                  message: "Please select phone code"
                }
              ]}
            >
              <Select
                className="secondary_variant"
                suffixIcon={
                  <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                }
                placeholder={"Select Code"}
              >
                {countries.map((ele, index) => (
                  <Select.Option key={`option_${index}`} value={ele.phonecode}>
                    {ele.flag} +{ele.phonecode}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              className="w-[calc(100%/4)] pr-6"
              name={"organizationInformationContactNumber"}
              rules={[
                {
                  required: true,
                  message: "Please enter contact number"
                },
                {
                  pattern: /^[0-9]*$/,
                  message: "Please enter a valid contact number"
                }
              ]}
            >
              <Input placeholder="Contact no." className={inputClass} />
            </Form.Item>
            {/* <div>
              <Button
                varient="rounded"
                borderColor="blue"
                className={
                  isCodeSent
                    ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal  "
                    : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800  text-blue-800 font-normal "
                }
                onClick={handleSentCode}
                disabled={isDisabledForm}
              >
                {isCodeSent ? "Re-send" : "Send Code"}
              </Button>
            </div>
            <div className="w-24 mr-4">
              <Input
                className={inputClass}
                value={inputCode}
                onChange={(e) => handleOtpInput(e)}
                type="text"
                placeholder="OTP"
              />
            </div>
            <div>
              <Button
                varient="rounded"
                className={
                  isVarifyCode
                    ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal  "
                    : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800  text-blue-800 font-normal "
                }
                onClick={handleVarifyCode}
                disabled={isDisabledForm}
              >
                {isVarifyCode ? "Varified" : "Verify"}
              </Button>
            </div> */}
          </div>
          <div className="flex">
            <Form.Item
              className="w-80"
              name="organizationInformationEmail"
              rules={[
                { type: "email", message: "The input is not a valid email" },
                { required: true, message: "Please enter your email" }
              ]}
            >
              <Input
                className={inputClass}
                type="email"
                placeholder="Email-id"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>

            <div>
              <Button
                varient="rounded"
                borderColor="blue"
                className={
                  isCode2Sent
                    ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal"
                    : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800 text-blue-800 font-normal"
                }
                onClick={handleSentCode2}
                disabled={isDisabledForm}
              >
                {isCode2Sent ? "Re-send" : "Send Code"}
              </Button>
            </div>

            <div className="w-24 mr-4">
              <Form.Item
                name="organizationInformationOtp"
                rules={[
                  { required: true, message: "Please enter the OTP" },
                  {
                    validator: (_, value) => {
                      if (isVarifyCode2) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("OTP must be verified"));
                    }
                  }
                ]}
              >
                <Input
                  className={inputClass}
                  value={inputCode2}
                  onChange={handleOtpInput2}
                  type="text"
                  placeholder="OTP"
                  disabled={isVarifyCode2}
                />
              </Form.Item>
            </div>

            <div>
              <Button
                varient="rounded"
                className={
                  isVarifyCode2
                    ? "w-32 mt-3 px-3 mx-4 text-green-500 border-2 border-green-500 font-normal"
                    : "w-32 mt-3 px-3 mx-4 border-2 border-blue-800 text-blue-800 font-normal"
                }
                onClick={handleVarifyCode2}
                disabled={isDisabledForm}
              >
                {isVarifyCode2 ? "Verified" : "Verify"}
              </Button>
            </div>
          </div>
        </div>
      </Form.Item>
      {userType != "seller" ? (
        <div>
          <p className="text-base text-[#252525] mb-6 mt-4">Registry details</p>
          <RegistryDetails
            registries={registries}
            isDisabledForm={isDisabledForm}
          />
        </div>
      ) : (
        <></>
      )}
      <Form.Item
        label={"Explain About Nature of Business"}
        name={"organizationInformationNatureOfBussiness"}
        rules={[
          {
            required: true,
            message: "Please enter about nature of Business"
          }
        ]}
        labelCol={{ span: 24 }}
      >
        <div className="text-area">
          <TextArea
            showCount
            maxLength={600}
            className="border-2 focus-within:shadow-none rounded-lg"
            style={{ height: 116, resize: "none" }}
          />
        </div>
      </Form.Item>
    </div>
  );
};
export default OrganizationForm;
